import * as React from "react";
import { IconWrapper } from "common/icons";
import PACKS from "app/common/icons/packs";

const styles = require("./createInputBox.scss");

interface IProps {
  onClickCreate: (text: string) => void;
  placeholder?: string;
}

interface IState {
  text: string;
  isFocused: boolean;
}

class CreateInputBox extends React.Component<IProps, IState> {
  public state: IState = {
    text: "",
    isFocused: false,
  };

  public render() {
    return <div className={styles.container}>{this.renderContent()}</div>;
  }

  private readonly renderContent = () => {
    return this.isEditMode() ? (
      <>
        <input
          autoFocus={true}
          className={styles.input}
          placeholder={this.props.placeholder}
          value={this.state.text}
          onChange={this.handleChangeText}
        />
        {this.renderAddButton()}
      </>
    ) : (
      <button
        className={styles.createIconButton}
        onClick={this.handleContainerClick}
      >
        <IconWrapper
          tagName="span"
          icon={PACKS.OVERLAY_TOOLTIP.ADD_ICON_NORMAL}
          className={styles.icon}
        />
      </button>
    );
  };

  private readonly renderAddButton = () => {
    const canCreate = this.state.text.length > 0;
    const inner = canCreate ? (
      <IconWrapper
        tagName="span"
        icon={PACKS.OVERLAY_TOOLTIP.ADD_ICON_ACTIVE}
        className={styles.icon}
      />
    ) : (
      <IconWrapper
        tagName="span"
        icon={PACKS.OVERLAY_TOOLTIP.ADD_ICON_NORMAL}
        className={styles.icon}
      />
    );

    return (
      <button
        className={styles.addButton}
        onClick={this.handleClickCreate}
        disabled={!canCreate}
      >
        {inner}
      </button>
    );
  };

  private readonly handleClickCreate = () => {
    this.props.onClickCreate(this.state.text.trim());
    this.setState({
      text: "",
    });
  };

  private readonly handleChangeText: React.ChangeEventHandler<
    HTMLInputElement
  > = e => {
    this.setState({
      text: e.currentTarget.value,
    });
  };

  private readonly handleContainerClick = () => {
    this.setState({
      isFocused: true,
    });
  };

  private readonly isEditMode = () =>
    this.state.text.length > 0 || this.state.isFocused;
}

export default CreateInputBox;
